(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
	jQuery( ".announcement-bar .announcement-bar__close" ).click(function(event) {
		event.preventDefault();
		
  		jQuery("#shopify-section-announcement-bar").css('display', 'none');
		jQuery("#shopify-section-header").css('top', '0px');
		console.log('tesst');
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog_body"] && !Shopify.designMode) return;
  try {
    

		function MainPagination() {       
               scrollNode = jQuery('#more_all').last();    
               scrollURL = jQuery('#more_all').last().attr("url");
               changeNode = jQuery('#more_all').last(); 
                pageNumber = jQuery('#more_all').last().attr("url");
             	pagesEnd = jQuery('.pagesEnd').text();
                pagesEnd = parseInt(pagesEnd);
               pageNumber =  parseInt(pageNumber.split('page=')[1]);
             	console.log(pageNumber);
				
               if(pagesEnd >= pageNumber){            	                   	
                    if(scrollNode.length > 0 && scrollNode.css('display') != 'none') {
                        jQuery.ajax({
                            type: 'GET',
                            url: scrollURL,
                            beforeSend: function() {
                                scrollNode.hide();
                            },
                            success: function(data) { 
                                var filteredData = jQuery(data).find("#product-grid li");
								jQuery("#product-grid").append(filteredData);
                                    pageNumber = pageNumber + 1; 
									if(pageNumber > pagesEnd){
										href = changeNode.attr("url");
                              			href = href.split("page=")[0];
                              			changeNode.attr("url", href+"page="+pageNumber.toString());
                              			changeNode.attr("style","display:none;");
                                		changeNode.insertBefore( jQuery("#product-list-foot") );
									}
									else{
										href = changeNode.attr("url");
                              			href = href.split("page=")[0];
                              			changeNode.attr("url", href+"page="+pageNumber.toString());
                              			changeNode.attr("style","");
                                		changeNode.insertBefore( jQuery("#product-list-foot") );
									}
                            },
                            dataType: "html"
                        });
                    }
               } 
           
         }
 
         jQuery(document).ready(function () {

			jQuery('#tag_all').addClass("current_tag");

           jQuery("#more_all").click(function(){
				
				
				console.log('clickk');
				MainPagination(); 
           });

			jQuery(".tag_button").click(function(){
				jQuery(".tag_button").removeClass("current_tag");
				jQuery(this).addClass("current_tag");
				
				//event.preventDefault();

				

				more_button = jQuery('#more_all').last();
				more_button_aux = jQuery('#more_all').last();
				scrollNode = jQuery(this).last();    
                 scrollURL = jQuery(this).last().attr("url");
                 changeNode = jQuery(this).last(); 
                  pageNumber = jQuery(this).last().attr("url");
                  pagesEnd = jQuery('.pagesEnd').text();
                  pagesEnd = parseInt(pagesEnd);
                      
                          jQuery.ajax({
                              type: 'GET',
                              url: scrollURL,
                              beforeSend: function() {
								  more_button.hide();
                              },
                              success: function(data) {
                                  var filteredData = jQuery(data).find("#product-grid li");
								  jQuery("#product-grid").html(filteredData);                                  
								
								
								  pageNumber = 2;
                                  href = more_button_aux.attr("url");
                                  href = href.split("page=")[0];
                                  more_button_aux.attr("url", href+"page="+pageNumber.toString());
								  var filteredData1 = jQuery(data).find(".pagesEnd");
								  jQuery('.pagesEnd').html(filteredData1.text());
								  pagesEnd = parseInt(filteredData1.text());
								  if(pageNumber > pagesEnd){
									more_button_aux.attr("style","display:none;");
								  }
								  else{
									more_button_aux.attr("style","");
								  }
                                  
                                  more_button_aux.insertBefore( jQuery("#product-list-foot") );
								  
								  
									
                              },
							  error: function(xhr) { // if error occured
                                  console.log("Error occured.please try again ::: " + xhr.statusText + xhr.responseText);
                              },
                              dataType: "html"
                          });
                     
                 
           });
         });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-panel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments;
        var context = this;
        clearTimeout(t);
        t = setTimeout(function () {
          fn.apply(context, args);
        }, wait);
      };
    }

    // Shifts every other wrapped row of thumbnails to the right, creating a
    // staggered "brick" look. Flex-wrap doesn't expose which items start a
    // new row (that depends on live container width), so rows are detected
    // by comparing each item's offsetTop after layout, then re-measured on
    // resize and whenever the theme editor reloads this section.
    //
    // Uses transform (not margin) to shift a row: a margin change would add
    // to that row's box width and throw off .feature-panel__thumbs's own
    // justify-content: center, visibly de-centering the whole block.
    // transform repaints without affecting layout, so every row still
    // centers correctly and only *looks* shifted.
    //
    // Desktop only: below 750px the row is usually only a few px narrower
    // than the container (three large circles nearly fill a phone-width
    // row), so there's rarely enough slack for the offset to read as an
    // actual stagger — it just looked like a display glitch. Mobile stays a
    // clean aligned grid instead.
    var desktopMql = window.matchMedia('(min-width: 750px)');

    function applyStagger(container) {
      var items = Array.prototype.slice.call(container.children);
      if (!items.length) return;

      items.forEach(function (item) {
        item.style.transform = '';
      });

      if (!desktopMql.matches) return;

      var rows = [];
      var rowTop = null;
      items.forEach(function (item) {
        var top = item.offsetTop;
        if (rowTop === null || top > rowTop + 1) {
          rows.push([]);
          rowTop = top;
        }
        rows[rows.length - 1].push(item);
      });

      if (rows.length < 2) return;

      var containerWidth = container.clientWidth;

      rows.forEach(function (rowItems, rowIndex) {
        if (rowIndex % 2 !== 1) return;

        var first = rowItems[0];
        var last = rowItems[rowItems.length - 1];
        var rowWidth = last.offsetLeft + last.offsetWidth - first.offsetLeft;
        var slack = containerWidth - rowWidth;
        var desired = Math.round(first.offsetWidth / 2 + 10);
        var offset = Math.max(0, Math.min(desired, slack));
        if (offset <= 0) return;

        rowItems.forEach(function (item) {
          item.style.transform = 'translateX(' + offset + 'px)';
        });
      });
    }

    function applyAll() {
      document.querySelectorAll('.feature-panel__thumbs--stagger').forEach(applyStagger);
    }

    function init() {
      applyAll();
      window.addEventListener('resize', debounce(applyAll, 150));
      document.addEventListener('shopify:section:load', applyAll);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
        
        
      
        
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
        
      if (window.pageYOffset > 50 ) {
      	this.header.classList.add('shopify-section-header-sticky');
      	this.closeMenuDisclosure();
      	this.closeSearchModal();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }
        
    

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      //if (this.currentScrollTop > 50 ) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      //CHANGE: STICKY HEADER ALWAYS VISIBLE
      //this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
	  this.header.classList.add('shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
